import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: grid;
	grid-template-columns: repeat(2, 34%);
	justify-content: space-between;
	width: 100%;
	height: 100%;
`;

const StyledBg = styled.div`
	width: 100%;
	height: 100%;
	background-color: #000000;
`;

export { StyledContainer, StyledBg };
